import { validateEmail } from '../../utils/inputValidator';
import { errorProcessor } from '../ajio-fetch/errorProcessor';

export function fetchGetJSONReqOpts(configObj = {}) {
  const defaultRequestObj = {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    },
    credentials: 'include'
  };
  let requestOptionObj = { ...defaultRequestObj };

  if (Object.keys(configObj).length) {
    for (const keys in configObj) {
      const obj = {};
      const newConfig = configObj[keys];

      if (defaultRequestObj.hasOwnProperty(keys)) {
        const defaultObj = defaultRequestObj[keys];
        if (typeof defaultObj !== 'object') {
          obj[keys] = configObj[keys];
        } else {
          obj[keys] = { ...defaultObj, ...newConfig };
        }
      } else {
        obj[keys] = configObj[keys];
      }
      requestOptionObj = { ...requestOptionObj, ...obj };
    }
  }
  return requestOptionObj;
}

export function getErrorStatusCode(err) {
  let { status, type = '' } = err;
  if (type == 'request-timeout') status = 504;
  return status;
}

export function errorParser(error = {}, statusCode = '') {
  return new Promise(resolve => {
    errorProcessor(error)
      .then(errorObject => {
        let flatErrorObject = {
          statusCode
        };

        /**
         * Error with code = 400 is only visible to user.
         * Other type of error will be silent from user UI but will be available in redux store.
         */

        if (statusCode === 400) {
          flatErrorObject = { ...flatErrorObject, errorType: 'info' };
        } else {
          flatErrorObject = { ...flatErrorObject, errorType: 'basic' };
        }

        if (errorObject.refreshToken) {
          flatErrorObject = { ...flatErrorObject, refreshToken: errorObject.refreshToken };
        }

        /**
         * Reading (errors) object from server response object and
         * based on type we are setting in flat structure.
         */

        let { errorMessage: { errors = '' } = {} } = errorObject;

        if (Array.isArray(errors)) {
          errors.map(item => {
            let errorObj = item;
            if (typeof item !== 'object') {
              errorObj = {};
              errorObj.message = JSON.stringify(item);
              errorObj.type = 'primitiveError';
            }
            flatErrorObject = { ...flatErrorObject, ...errorObj };
          });
        } else if (typeof errors === 'object') {
          flatErrorObject = { ...flatErrorObject, ...errors };
        } else {
          const errorObj = {};
          //  remove error Something went wrong. Try again
          errors = errors || '';
          errorObj.message = JSON.stringify(errors);
          errorObj.type = 'primitiveError';
          flatErrorObject = { ...flatErrorObject, ...errorObj };
        }

        if (!flatErrorObject.message) {
          flatErrorObject = {
            ...flatErrorObject,
            message: 'Sorry !! Currently we are unable reach our server.',
            errorType: 'info'
          };
        }
        const { statusText = '', url = '' } = error;
        const { message = '' } = flatErrorObject;
        const formattedUrlArr = url.split('/') || [];
        const { length } = formattedUrlArr;
        let formattedUrl = [];
        for (let i = 0; i < length; i++) {
          if (validateEmail(formattedUrlArr[i])) {
            formattedUrl.push(' ');
          } else {
            formattedUrl.push(formattedUrlArr[i]);
          }
        }

        formattedUrl = formattedUrl.join('/');
        if (window) {
          window.GA_Error = {
            statusCode,
            statusText,
            message,
            url: formattedUrl,
            date: new Date()
          };
        }
        resolve(flatErrorObject);
      })
      .catch(errorInErrorObject => {
        /**
         * Explicitly setting for slient exit if parsing fails for error object.
         * So that the user is blocked. Need to track this kind of slient exit in GA.
         *
         */
        try {
          const eventCategory = 'serviceErrorEvent';
          const eventAction = _get(error, 'url', 'UnkownUrl');
          const eventLabel = '404: Oops !! something went wrong. Try after sometime.';
          ga.gaSendEvent(eventCategory, eventAction, eventLabel);
        } catch (error) {
          console.log('Unable to send.', error);
        }
        resolve({
          statusCode: 404,
          errorType: 'info',
          type: 'FailedToParseError',
          message: 'Oops !! something went wrong. Try after sometime.'
        });
      });
  });
}

export function fetchGetJSONResHandler(response) {
  return !response.ok ? Promise.reject(response) : response.json();
}
